/*
Controller: Binaries

Operations:
  getBinaries
  uploadBinary
  deleteBinaries
  deleteBinary
  getBinary
  createPresignedUrl
*/
var Api = require('../config')
var CreateBinaryRequestDef = require('../definitions/CreateBinaryRequest')
var BinariesDeleteRequestDef = require('../definitions/BinariesDeleteRequest')
var CreatePresignedUrlRequestDef = require('../definitions/CreatePresignedUrlRequest')

var Binaries = (function () {
  /*
  Operation: getBinaries
  Get all binaries metadata
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Collection of Binaries of this submission
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getBinariesBinaries (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/binaries'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: uploadBinary
  Upload font binaries
  Parameters:
    submissionId: Id of the submission

  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed. This could be due to file format issues, file size etc.
    HTTP 403: Operation not permitted
  */
  function uploadBinaryBinaries (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        CreateBinaryRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}/binaries'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteBinaries
  Delete font binaries
  Parameters:
    submissionId: Id of the submission
    bodyRequest: Binary Ids to be deleted
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete binary
    HTTP 403: Operation not permitted
    HTTP 404: Binary not found
  */
  function deleteBinariesBinaries (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        BinariesDeleteRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}/binaries/delete'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteBinary
  Delete binary
  Parameters:
    binaryId: Id of binary
    submissionId: Id of the submission
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete binary
    HTTP 403: Operation not permitted
    HTTP 404: Binary not found
  */
  function deleteBinaryBinaries (binaryId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!binaryId) {
          throw new Error('binaryId: Missing parameter')
        }
        if (binaryId && !(typeof binaryId === 'string')) {
          throw new Error('binaryId: Wrong type: Got "' + (typeof binaryId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/binaries/{binaryId}'
      path = path.replace('{' + 'binaryId' + '}', binaryId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getBinary
  Get uploaded binary file metadata
  Parameters:
    binaryId: Id of binary
    submissionId: Id of the submission
  Responses:
    HTTP 200: Binary found
    HTTP 403: Operation not permitted
    HTTP 404: Binary not found
  */
  function getBinaryBinaries (binaryId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!binaryId) {
          throw new Error('binaryId: Missing parameter')
        }
        if (binaryId && !(typeof binaryId === 'string')) {
          throw new Error('binaryId: Wrong type: Got "' + (typeof binaryId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/binaries/{binaryId}'
      path = path.replace('{' + 'binaryId' + '}', binaryId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createPresignedUrl
  This accepts multiple MD5s in the request and returns presigned URLs for uploading the files.
  Parameters:
    submissionId: Id of the submission

  Responses:
    HTTP 200: Presigned URL for the provided MD5
    HTTP 400: md5 not valid.
    HTTP 403: Operation not permitted
  */
  function createPresignedUrlBinaries (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        CreatePresignedUrlRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}/binaries/createPresignedUrl'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getBinaries'] = getBinariesBinaries
  ret['uploadBinary'] = uploadBinaryBinaries
  ret['deleteBinaries'] = deleteBinariesBinaries
  ret['deleteBinary'] = deleteBinaryBinaries
  ret['getBinary'] = getBinaryBinaries
  ret['createPresignedUrl'] = createPresignedUrlBinaries
  return ret
})()

module.exports = Binaries
